import validate from 'validate.js';

const constraints = {
    name: {
	presence: { 
	    message: 'napiši ime'
	}
    }
}

const AlbumValidator = ( fields ) => {
    var validations= validate(fields, constraints, {fullMessages: false}) || {};
 
    return validations
}

export default AlbumValidator ;



// WEBPACK FOOTER //
// ./src/validators/AlbumValidator.js